import { Box, Typography } from '@mui/material'

/** A label/value pair for the read-only marketing detail dialogs. Long text wraps rather than clips. */
export function DetailField({ label, value }: { label: string; value: string }) {
  return (
    <Box>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>
        {value}
      </Typography>
    </Box>
  )
}
